import React from 'react';
export const ResultsSection = () => {
  return <section id="results" className="w-full py-12 bg-green-900/10" data-id="element-207">
      <div className="container mx-auto px-4" data-id="element-208">
        <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-4 text-center" data-id="element-209">
          84% of Daily Foundation Chew Subscribers Surveyed Are Seeing Results
          After 3 Months of Daily Use
        </h2>
        <p className="text-green-900/80 mb-8 text-center max-w-3xl mx-auto" data-id="element-210">
          Because The Daily Foundation Chew works progressively to restore gut
          balance from the inside out, the benefits compound over time:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-211">
          <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-212">
            <h3 className="text-xl font-bold text-green-900 mb-4" data-id="element-213">
              Weeks 1-2: Digestive Harmony
            </h3>
            <ul className="text-green-900/80 space-y-2" data-id="element-214">
              <li data-id="element-215">• Firmer, more regular stools</li>
              <li data-id="element-216">• Dramatic reduction in gas</li>
              <li data-id="element-217">• Less stomach gurgling</li>
              <li data-id="element-218">• Improved appetite</li>
            </ul>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-219">
            <h3 className="text-xl font-bold text-green-900 mb-4" data-id="element-220">
              Weeks 3-6: Visible Vitality
            </h3>
            <ul className="text-green-900/80 space-y-2" data-id="element-221">
              <li data-id="element-222">• Noticeably increased energy</li>
              <li data-id="element-223">• Shinier, healthier coat</li>
              <li data-id="element-224">• Reduced itching and scratching</li>
              <li data-id="element-225">• Better breath</li>
            </ul>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-226">
            <h3 className="text-xl font-bold text-green-900 mb-4" data-id="element-227">
              Weeks 6-12: Mobility Restored
            </h3>
            <ul className="text-green-900/80 space-y-2" data-id="element-228">
              <li data-id="element-229">• Easier movement, especially mornings</li>
              <li data-id="element-230">• More interest in activities</li>
              <li data-id="element-231">• Less stiffness after rest</li>
              <li data-id="element-232">• Acting years younger</li>
            </ul>
          </div>
          <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-233">
            <h3 className="text-xl font-bold text-green-900 mb-4" data-id="element-234">
              3+ Months: Total Transformation
            </h3>
            <ul className="text-green-900/80 space-y-2" data-id="element-235">
              <li data-id="element-236">• Strong immune system</li>
              <li data-id="element-237">• Rare digestive issues</li>
              <li data-id="element-238">• Consistent energy</li>
              <li data-id="element-239">• Overall thriving health</li>
            </ul>
          </div>
        </div>
        <div className="flex justify-center" data-id="element-240">
          <a href="#comparison" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-3 px-8 rounded-full text-lg shadow-md transition duration-300 inline-block" data-id="element-241">
            LEARN MORE
          </a>
        </div>
      </div>
    </section>;
};